import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListDarkRailIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items = [],
}: StoryListDarkRailIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["headline", "url"]);
}
